<template>
  <div>
    <!-- 드림시큐리티 -->
    <div v-if="issuer === 'dream'" :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
      <div class="label" :style="labelStyle">
        <p>{{itemSetting.action.label[lang]}}</p>
        <span v-if="passed !== null && passed === false" class="validateMessage">({{locale.required}})</span>
      </div>
      <button type="button" class="btn btnFull" @click="cert">
        {{item.value[lang]}}
      </button>
      <div v-if="authInfo" class="notranslate mt15">
        <div class="mb10">
          <div class="label" :style="labelStyle"><p>{{locale.name}}</p></div>
          <input type="text" class="input" :value="authInfo.name" disabled>
        </div>
        <div class="mb10">
          <div class="label" :style="labelStyle"><p>{{locale.telephone}}</p></div>
          <input type="text" class="input" :value="authInfo.phone" disabled>
        </div>
        <div>
          <div class="label" :style="labelStyle"><p>{{locale.birthdate}}</p></div>
          <input type="text" class="input" :value="authInfo.birthDate" disabled>
        </div>
      </div>
      <!-- cert form -->
      <form name="reqDRMOKForm" method="post">
        <input type="hidden" name="req_info" :value="reqInfo">
        <input type="hidden" name="rtn_url" :value="rtnUrl">
        <input type="hidden" name="cpid" :value="cpId">
        <input type="hidden" name="newpop" value="Y">
      </form>
      <!-- //cert form -->
    </div>
    <!-- //드림시큐리티 -->
    <!-- 카카오 인증 -->
    <div v-else-if="issuer === 'kakao'">
      <div v-if="authInfo" class="notranslate">
        <div class="formGroup mb15" :class="{isRequired: itemSetting.action.isRequired}">
          <div class="label" :style="labelStyle"><p>{{locale.telephone}}</p></div>
          <input type="text" class="input" v-model="authInfo.phone" disabled>
        </div>
        <div class="formGroup mb15" :class="{isRequired: itemSetting.action.isRequired}">
          <div class="label" :style="labelStyle">
            <p>{{locale.name}}</p>
            <span v-if="authInfo.name === ''" class="validateMessage">({{locale.required}})</span>
          </div>
          <input type="text" class="input" v-model="value.name">
        </div>
        <div class="formGroup" :class="{isRequired: itemSetting.action.isRequired}">
          <div class="label" :style="labelStyle">
            <p>{{locale.birthdate}}</p>
            <span v-if="!validBirthDate" class="validateMessage">({{locale.required}})</span>
          </div>
          <input type="text" class="input" v-model="value.birthDate" @input="numberOnly" placeholder="19990101">
        </div>
      </div>
      <div v-else class="formGroup isRequired">
        <div class="label" :style="labelStyle">
          <p>{{itemSetting.action.label[lang]}}</p>
          <span class="validateMessage">({{locale.required}})</span>
        </div>
        <p class="colorGrey">{{locale.message_required_authid}}</p>
      </div>
    </div>
    <!-- //카카오 인증 -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import regExp from '@/common/regExp'

export default {
  name: 'Cert',
  props: [
    'id',
    'item',
    'itemSetting',
    'lang',
    'locale'
  ],
  computed: {
    ...mapGetters({
      submitData: 'submit/getSubmitData'
    }),
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    value: {
      get () {
        const data = typeof (this.submitData.find(x => x.id === this.id)) === 'undefined' ? '' : this.submitData.find(x => x.id === this.id).value
        return data
      },
      set (value) {
        const passed = !this.itemSetting.action.isRequired
          ? null
          : this.issuer === 'dream'
            ? true
            : value.name !== '' && value.birthDate !== ''
        const data = {
          id: this.id,
          value: value,
          passed: passed
        }
        this.$store.commit('submit/setValue', data)
      }
    },
    passed () {
      return this.submitData && this.submitData.find(x => x.id === this.id)
        ? this.submitData.find(x => x.id === this.id).passed
        : null
    },
    validBirthDate () {
      return this.authInfo.birthDate.length === 8
    }
  },
  watch: {
    authId (authId) {
      const newWin = this.newWin
      if (authId && !newWin) {
        const data = {
          authId: authId
        }
        this.$store.dispatch('submit/getCertInfo', data).then((res) => {
          if (res) {
            const isPassed = this.issuer === 'dream'
            const info = {
              id: this.id,
              value: {
                name: res.name || '',
                birthDate: res.birthDate || '',
                phone: res.phone || '',
                ...res
              },
              passed: isPassed
            }
            this.authInfo = info.value
            this.$store.commit('submit/setValue', info)
          }
          localStorage.removeItem('caId')
        })
      }
    },
    authInfo: {
      deep: true,
      handler (value) {
        const passed = !this.itemSetting.action.isRequired
          ? null
          : this.issuer === 'dream'
            ? true
            : value.name !== '' && value.birthDate !== ''
        const data = {
          id: this.id,
          value: value,
          passed: passed
        }
        this.$store.commit('submit/setValue', data)
      }
    }
  },
  created () {
    const params = (new URL(document.location)).searchParams
    const completeAuth = params.get('authId') // 본인인증 후 리다이렉션된 새창?
    this.$store.dispatch('authentication/getExpressCheckinInfo').then((res) => {
      const issuer = res.selfAuth
      this.issuer = res.selfAuth
      if (issuer === 'dream') {
        if (completeAuth) {
          this.newWin = completeAuth
          localStorage.setItem('caId', completeAuth)
        }
        setInterval(() => {
          this.checkAuthId()
        }, 100)
      } else if (issuer === 'kakao') {
        if (completeAuth) {
          this.authId = completeAuth
        }
      }
    })
  },
  data () {
    return {
      issuer: '',
      cpId: '',
      reqInfo: '',
      rtnUrl: '',
      newWin: false,
      authId: null,
      authInfo: null
    }
  },
  methods: {
    checkAuthId () {
      const caId = localStorage.getItem('caId')
      if (caId) {
        this.authId = caId
        if (this.newWin) {
          window.close()
        } else {
          this.$store.commit('loading', false)
          clearInterval(this.checkAuthId)
        }
      }
    },
    numberOnly (e) {
      this.authInfo.birthDate = regExp.numberOnly(e.target.value)
    },
    cert () {
      const data = {
        returnUrl: window.location.href
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('submit/launchCert', data).then((res) => {
        if (res) {
          this.cpId = res.id
          this.reqInfo = res.data
          this.rtnUrl = res.returnUrl
          this.launch()
          // this.$store.commit('loading', false)
        }
        setTimeout(() => {
          this.$store.commit('loading', false)
        }, 2000)
      })
    },
    launch () {
      let drmOkWindow
      function openDRMOKWindow () {
        drmOkWindow = window.open('', 'DRMOKWindow', 'width=200, height=360, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250')
        if (drmOkWindow == null) {
          alert('※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는\n화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다.\n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.')
        }
        document.reqDRMOKForm.action = 'https://www.mobile-ok.com/popup/common/hscert.jsp'
        document.reqDRMOKForm.target = 'DRMOKWindow'
        document.reqDRMOKForm.submit()
      }
      setTimeout(() => {
        openDRMOKWindow()
      }, 1200)
    }
  }
}
</script>
